<template>
  <div>
    <page-title
      icon="fa fa-shopping-cart"
      main="Campanha"
      sub="Campanhas"
      :help="true"
      titleHelp="Ajuda - Campanhas"
      content="Responsável por listar e cadastrar Campanhas.
Para pesquisar apenas as Campanhas ligadas a Safra Boa, pressione o botão Safra Boa.
Para pesquisar apenas as Campanhas ligadas a Milho Bom, pressione o botão Milho Bom.
Para criação de uma Campanha Safra Boa pressione o botão no canto superior direito 'Nova Safra Boa'.
Para criação de uma Campanha Milho Bom pressione o botão no canto superior direito 'Milho Bom'.
Para alteração de uma Campanha basta ir com o mouse em ações e clicar em Editar."
    >
      <template v-slot:actions>
        <base-button @click="newCampaign" type="neutral" class="ml-3 mb-2" size="sm"
          >Safra Boa</base-button
        >
        <base-button @click="newCampaignz" type="neutral" class="ml-3 mb-2" size="sm"
          >Milho Bom</base-button
        >
      </template>
    </page-title>

    <!-- MODAL SAFRA BOA-->
    <modal :show.sync="modals.harvest" id="cadastrar-seções">
      <template slot="header">
        <h5 class="modal-title">
          {{isCreatingSb ? "Cadastrar" : "Editar"}} Safra Boa
        </h5>
      </template>
      <validation-observer ref="observer">
        <form role="form">
          <div class="row">
            <div class="col-md-12">
              <base-input
                label="Nome da Campanha"
                name="name"
                placeholder="Digite o nome da campanha"
                v-model="campaign.name"
                :required="true"
                @input="errors.name = null"
              />
              <div v-if="errors.name " class="invalid-feedback" style="display: block;">
                {{ errors.name }}
              </div>
            </div>
            <div class="col-md-12">
              <label class="form-control-label d-block mb-3">Vigência</label>
              <base-input addon-left-icon="ni ni-calendar-grid-58">
                <el-date-picker
                  v-model="dateRange"
                  :key="dateRange.join()"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="Data início"
                  end-placeholder="Data fim"
                  unlink-panels
                  prefix-icon="fa fa-calendar"
                  format="d 'de' MMMM 'de' yyyy"
                  rules="required"
                  :editable="true"
                  :required="true"
                  :clearable="false"
                />
              </base-input>
              <span v-if="this.campaign.start_date || this.campaign.end_date" class="custom-clear-icon" @click="handleClearIconClick">
                <i class="button-class fas fa-times-circle"></i>
              </span>
            </div>

            <div class="col-md-12 mb-2">
                <label class="form-control-label">Fornecedor do Produto <span class="text-warning">*</span></label>
                <multiselect
                  v-model="campaign.brand"
                  :options="brands"
                  :select-label="''"
                  :deselect-label="''"
                  :selected-label="'Selecionado'"
                  placeholder="Selecionar Fornecedor"
                  label="name"
                  rules="required"
                  :allow-empty="true"
                  @close="onTouch('type')"
                  track-by="id"
                  @search-change="loadBrands"
                  @input="errors.brand = null"
                ></multiselect>
                <div v-if="errors.brand " class="invalid-feedback" style="display: block;">
                  {{ errors.brand  }}
                </div>
            </div>

            <div class="col-md-12 mb-2" style="padding-top: 1rem;">
                <label class="form-control-label">Produto Chave <span class="text-warning">*</span></label>
                <multiselect
                  v-model="campaign.preferredproduct"
                  :options="preferredproducts"
                  :select-label="''"
                  :deselect-label="''"
                  :selected-label="'Selecionado'"
                  placeholder="Selecionar Produto chave"
                  label="name"
                  name="product"
                  rules="required"
                  :allow-empty="true"
                  :block-keys="['Tab', 'Enter']"
                  @close="onTouch('type')"
                  track-by="id"
                  @search-change="searchProducts"
                  @input="errors.preferredproduct = null"
                >
                </multiselect> 
                <div v-if="errors.preferredproduct " class="invalid-feedback" style="display: block;">
                  {{ errors.preferredproduct }}
                </div>
            </div>

              <div class="col-md-12 mb-2" style="padding-top: 1rem;">
                <label class="form-control-label col-12" style="margin-left: -10px;">Empresa <span class="text-warning">*</span></label>
                <el-select
                  v-model="campaign.enterprises"
                  label="Empresa"
                  filterable
                  multiple
                  remote
                  style="width: 100%;"
                  size="large"
                  collapse-tags
                  :loading="isLoadingEnterprise"
                  @input="errors.enterprises = null"
                >
                  <el-option
                    v-for="enterprise in enterprises"
                    name="enterprise"
                    :key="enterprise.codi_emp"
                    :label="enterprise.iden_emp"
                    :value="enterprise.codi_emp"
                    :block-keys="['Tab', 'Enter']"
                   />
                </el-select>
                <div v-if="errors.enterprises " class="invalid-feedback" style="display: block;">
                  {{ errors.enterprises  }}
                </div>
              </div>

            <div class="col-md-12 mb-2" style="padding-top: 1rem;">
              <label class="form-control-label col-12">Produtos Participantes</label>
              <el-select
                v-model="campaign.preferredproduct_ids"
                label="Produtos"
                filterable
                multiple
                size="large"
                remote
                style="width: 100%;"
                collapse-tags
                :remote-method="searchProducts"
              >
                <el-option
                  v-for="preferredproduct in filterPreferredproducts"
                  name="product"
                  class="product-participant"
                  :key="preferredproduct.id"
                  :label="preferredproduct.name"
                  :value="preferredproduct.id"
                  :block-keys="['Tab', 'Enter']"
                  @close="onTouch('type')"
                />
              </el-select>

              <div class="row justify-content-between mt-2 mr-2">
                <base-button
                  class="button-imovel ml-4 mt-2"
                  type="secundary"
                  @click="addCampaignHarvest"
                  size="sm"
                  style="color: #2dce89;"
                >
                  <i class="ni ni-fat-add"></i>
                  Adicionar Condição
                </base-button>
              </div>
            </div>
            <div
              class="col-md-12 mb-2"
              v-for="harvest in campaign.percentages_campaigns_attributes"
              :key="harvest.id"
            >
              <div v-if="harvest._destroy !== '1'">
                <div class="col-md-12 mb-3" style="padding-top: 1rem;">
                  <base-input
                    label="Condição da Campanha"
                    placeholder="0"
                    name="brand_percentage"
                    :valid="true"
                    mask="money"
                    v-model="harvest.condition"
                    aria-label="Informe a condição da campanha"
                    :required="true"
                  />
                </div>
                <div class="col-md-12">
                  <base-input
                    label="Porcentagem do Produto"
                    :valid="true"
                    name="brand_percentage"
                    placeholder="0"
                    append-icon="fa fa-percent"
                    v-model="harvest.discount_percentage"
                    aria-label="Informe a porcentagem da Marca"
                    :required="true"
                  />
                </div>

                <div class="col-md-12">
                  <base-input
                    label="Porcentagem de Desconto por Produto"
                    placeholder="0"
                    name="discount_percentage"
                    append-icon="fa fa-percent"
                    :valid="true"
                    v-model="harvest.product_percentage"
                    aria-label="Informe a porcentagem de desconto"
                    :required="true"
                  />
                </div>
                <div class="row justify-content-between">
                  <base-button
                    type="secundary"
                    @click="removeHarvest(harvest)"
                    style="color: #f5365c;"
                    size="sm"
                    class="mt-2 ml-4"
                  >
                    Remover
                    <i class="ni ni-fat-delete"></i>
                  </base-button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </validation-observer>
      <template slot="footer">
        <base-button
          type="secondary"
          class="mr-2"
          @click="modals.harvest = false"
          >Fechar</base-button
        >
        <base-button type="success" @click="save">Salvar</base-button>
      </template>
    </modal>

    <!-- MODAL MILHO BOM-->
    <modal :show.sync="modals.corn" id="cadastrar-seções">
      <template slot="header">
        <h5 class="modal-title">
          {{ isCreatingMb? "Cadastrar" : "Editar" }} Milho Bom
        </h5>
      </template>
      <validation-observer ref="observer">
        <form role="form">
          <div class="row">
            <div class="col-md-12">
              <base-input
                label="Nome da Campanha"
                name="name"
                placeholder="Digite o nome da campanha"
                v-model="campaign.name"
                @input="errorMilhoBom.name = null"
                :required="true"
              />
              <div v-if="errorMilhoBom.name " class="invalid-feedback" style="display: block;">
               {{ errorMilhoBom.name  }}
              </div>
            </div>

            <div class="col-md-12">
              <label class="form-control-label d-block mb-3">Vigência</label>
              <base-input addon-left-icon="ni ni-calendar-grid-58">
                <el-date-picker
                  v-model="dateRange"
                  :key="dateRange.join()"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="Data início"
                  end-placeholder="Data fim"
                  unlink-panels
                  prefix-icon="fa fa-calendar"
                  format="d 'de' MMMM 'de' yyyy"
                  rules="required"
                  :editable="true"
                  :clearable="false"
                />
              </base-input>
              <span v-if="this.campaign.start_date || this.campaign.end_date" class="custom-clear-icon" @click="handleClearIconClick">
                <i class="button-class fas fa-times-circle"></i>
              </span>
            </div>

            <div class="col-md-12 mb-2">
                <label class="form-control-label col-12" style="margin-left: -10px;"
                  >Fornecedores do Produto <span class="text-warning">*</span>
                </label>
                <el-select
                  v-model="campaign.providers"
                  label="Produtos"
                  filterable
                  multiple
                  remote
                  style="width: 100%;"
                  size="large"
                  collapse-tags
                  @change="loadBrands"
                  @close="onTouch('type')"
                  @input="errorMilhoBom.providers = null"
                >
                  <el-option
                    v-for="brand in brands"
                    name="brand"
                    :key="brand.id"
                    :label="brand.name"
                    :value="brand.id"
                    :block-keys="['Tab', 'Enter']"
                    @close="onTouch('type')"
                  />
                </el-select>
                <div v-if="errorMilhoBom.providers " class="invalid-feedback" style="display: block;">
                  {{ errorMilhoBom.providers  }}
                </div>
            </div>

            <div class="col-md-12 mb-2" style="padding-top: 1rem;">
                <label class="form-control-label col-12" style="margin-left: -10px;">Produtos Chave <span class="text-warning">*</span></label>
                <el-select
                  v-model="campaign.key_products"
                  label="Empresa"
                  filterable
                  multiple
                  remote
                  collapse-tags
                  style="width: 100%;"
                  size="large"
                  @input="errorMilhoBom.key_products = null"
                >
                  <el-option
                    v-for="preferredproduct in preferredproducts"
                    name="preferredproduct"
                    :key="preferredproduct.id"
                    :label="preferredproduct.name"
                    :value="preferredproduct.id"
                    :block-keys="['Tab', 'Enter']"
                  />
                </el-select>
                <div v-if="errorMilhoBom.key_products " class="invalid-feedback" style="display: block;">
                  {{ errorMilhoBom.key_products  }}
                </div>
            </div>

            <div class="col-md-12" style="padding-top: 1rem;">
              <label class="form-control-label col-12" style="margin-left: -10px;">Produtos Participantes <span class="text-warning">*</span></label>
                <el-select
                  v-model="campaign.preferredproduct_ids"
                  label="Produtos"
                  filterable
                  multiple
                  remote
                  style="width: 100%;"
                  size="large"
                  collapse-tags
                  @input="errorMilhoBom.preferredproduct_ids = null"
                >
                  <el-option
                    v-for="preferredproduct in preferredproducts"
                    name="product"
                    :key="preferredproduct.id"
                    :label="preferredproduct.name"
                    :value="preferredproduct.id"
                    :block-keys="['Tab', 'Enter']"
                    @close="onTouch('type')"
                  />
                </el-select>
                <div v-if="errorMilhoBom.preferredproduct_ids " class="invalid-feedback" style="display: block;">
                  {{ errorMilhoBom.preferredproduct_ids  }}
                </div>
            </div>

            <div class="col-md-12 mb-2" style="padding-top: 1rem;">
              <label class="form-control-label col-12" style="margin-left: -10px;">Fornecedores Milho</label>
              <el-select
                v-model="campaign.corn_providers"
                label="Fornecedores Milho"
                filterable
                multiple
                remote
                size="large"
                style="width: 100%;"
                collapse-tags
                @change="this.loadBrands()"
              >
                <el-option
                  v-for="brand in brands"
                  name="brand"
                  :key="brand.id"
                  :label="brand.name"
                  :value="brand.id"
                  :block-keys="['Tab', 'Enter']"
                  @close="onTouch('type')"
                >
                </el-option>
              </el-select>
            </div>

            <div class="col-md-12 mb-2" style="padding-top: 1rem;">
              <label class="form-control-label col-12" style="margin-left: -10px;">Empresa <span class="text-warning">*</span></label>
                <el-select
                  v-model="campaign.enterprises"
                  label="Empresa"
                  filterable
                  multiple
                  remote
                  style="width: 100%;"
                  size="large"
                  collapse-tags
                  :loading="isLoadingEnterprise"
                  @input="errorMilhoBom.enterprises = null"
                >
                  <el-option
                    v-for="enterprise in enterprises"
                    name="enterprise"
                    :key="enterprise.codi_emp"
                    :label="enterprise.iden_emp"
                    :value="enterprise.codi_emp"
                    :block-keys="['Tab', 'Enter']"
                  />
                </el-select>
              <div v-if="errorMilhoBom.enterprises " class="invalid-feedback" style="display: block;">
                {{ errorMilhoBom.enterprises  }}
              </div>
            </div>

            <div class="row justify-content-between">
              <base-button
                class="button-imovel ml-3"
                type="secundary"
                @click="addCampaignCorn"
                size="sm"
                style="color: #2dce89; margin-left: 12px;"
              >
                <i class="ni ni-fat-add"></i>
                Adicionar Campos
              </base-button>

              <base-button
                type="secundary"
                @click="removeCorn(corn)"
                style="color: #f5365c;"
                size="sm"
                class="ml-3"
              >
                <i class="ni ni-fat-delete"></i>
              </base-button>
            </div>

            <div
              class="row col-md-12 mb-2"
              v-for="corn in campaign.percentages_campaigns_attributes"
              :key="corn.id"
            >
              <div class="col-md-12 mb-3" style="padding-top: 1rem;">
                <base-input
                  label="Condição da Campanha"
                  placeholder="0"
                  name="brand_percentage"
                  :valid="true"
                  mask="money"
                  v-model="corn.condition"
                  aria-label="Informe a condição da campanha"
                  :required="true"
                ></base-input>
              </div>

              <div class="col-md-12">
                <base-input
                  label="Porcentagem do Produto"
                  placeholder="0"
                  mask="percentage"
                  name="brand_percentage"
                  append-icon="fa fa-percent"
                  :valid="true"
                  v-model="corn.product_percentage"
                  aria-label="Informe a porcentagem do produto"
                  :required="true"
                ></base-input>
              </div>

              <div class="col-md-12">
                <base-input
                  label="Quantidade Mínima de Sacos de Milho"
                  :valid="true"
                  placeholder="0"
                  mask="volume"
                  v-model="corn.corn_bags"
                  aria-label="Informe a quantidade de sacos de milho"
                  :required="true"
                ></base-input>
              </div>

              <div class="col-md-12">
                <base-input
                  label="Porcentagem Adicional por Saco de Milho"
                  :valid="true"
                  v-model="corn.discount_percentage"
                  :required="true"
                  placeholder="0"
                  mask="percentage"
                  name="percentage"
                  append-icon="fa fa-percent"
                />
              </div>

              <div class="col-md-12">
                <base-input
                  label="Porcentagem Minima"
                  placeholder="0"
                  name="discount_percentage"
                  append-icon="fa fa-percent"
                  :valid="true"
                  v-model="corn.corn_percentage"
                  :required="true"
                ></base-input>
              </div>
            </div>
          </div>
        </form>
      </validation-observer>
      <template slot="footer">
        <base-button type="secondary" @click="modals.corn = false"
          >Fechar</base-button
        >
        <base-button type="success" @click="save">Salvar</base-button>
      </template>
    </modal>

    <card>
      <div slot="header"><span>Campanhas</span></div>
      <div>
        <base-button
          type="primary"
          @click="clickedSb"
          class="ml-1"
          style="margin: 0.5rem;"
          >Safra Boa</base-button
        >
        <base-button type="primary" @click="clickedMb" style="margin: 0.5rem;"
          >Milho Bom</base-button
        >
      </div>

      <!-- CARD SAFRA BOA-->
      <card v-if="condition_1">
        <h3 class="mb-4">Campanhas Safra Boa</h3>
        <form>
          <div class="row">
            <div class="col-md-10">
              <base-input
                label="Nome da Campanha"
                placeholder="Safra Boa Bayer"
                v-model="filter.name"
              />
            </div>
            <div class="col-md-2 mb-2">
              <div style="margin-top: 2rem;">
                <base-button icon type="primary" v-on:click="search">
                  <span class="btn-inner--icon"
                    ><i class="fa fa-search"></i
                  ></span>
                  <span class="btn-inner--text">Pesquisar</span>
                </base-button>
              </div>
            </div>
          </div>
        </form>

        <el-table
          v-loading="isLoading"
          class="table-responsive table-striped clickable-rows"
          header-row-class-name="thead-light"
          style="width: 100% !important; padding-top: 10px;"
          :data="campaigns"
          ref="campaigns"
        >
          <el-table-column label="Nome" prop="name" min-width="200px" sortable />
          <el-table-column label="Data Início" v-slot="{ row }" min-width="130px" sortable>
            {{ row.start_date | humanDate }}
          </el-table-column>
          <el-table-column label="Data Fim" v-slot="{ row }" min-width="130px" sortable>
            {{ row.end_date | humanDate }}
          </el-table-column>
          <el-table-column label="Ações" min-width="120px" v-slot="{ row }">
            <div class="row">
              <el-dropdown
                trigger="hover"
                class="dropdown"
                style="cursor: pointer;"
              >
                <span class="btn btn-sm btn-icon-only text-success">
                  <i class="fas fa-ellipsis-v mt-2"></i>
                </span>
                <el-dropdown-menu
                  class="dropdown-menu dropdown-menu-arrow show"
                  slot="dropdown"
                >
                  <a class="dropdown-item" href="#" @click="edit(row)"
                    >Editar</a
                  >
                  <a class="dropdown-item" href="#" @click.prevent="remove(row)"
                    >Excluir</a
                  >
                  <a
                    class="dropdown-item"
                    href="#"
                    @click="openModal('synthetic', row)"
                  >
                    Apuração Sintética
                  </a>
                  <a
                    class="dropdown-item"
                    href="#"
                    @click="openModal('analytical', row)"
                  >
                    Apuração Analítica
                  </a>
                </el-dropdown-menu>
              </el-dropdown>
              <el-tooltip
                v-if="row.percentages_campaigns.length > 0"
                content="Visualizar Descontos"
                placement="top"
              >
                <a @click="rowClicked(row, true)">
                  <span class="btn btn-sm btn-icon-only text-success">
                    <i class="fa fa-eye mt-2"></i>
                  </span>
                </a>
              </el-tooltip>
            </div>
          </el-table-column>

          <el-table-column :min-width="1" type="expand" prop="campaign">
            <template align="right" slot-scope="props">
              <div>
                <div
                  class="card-deck"
                  v-for="percentages_campaign in props.row
                    .percentages_campaigns"
                  :key="percentages_campaign.id"
                >
                  <card>
                    <h5 class="card-title">Condição</h5>
                    <div v-if="rowExpanded" class="tags-input__wrapper">
                      R$ {{ percentages_campaign.condition || 0 }}
                    </div>
                  </card>
                  <card>
                    <h5 class="card-title">Porcentagem de Desconto</h5>
                    <div v-if="rowExpanded" class="tags-input__wrapper">
                      {{ percentages_campaign.discount_percentage || 0 }}%
                    </div>
                  </card>
                  <card>
                    <h5 class="card-title">Porcentagem do Produto</h5>
                    {{ percentages_campaign.product_percentage || 0 }}%
                  </card>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="py-4 d-flex justify-content-end">
          <base-pagination
            v-on:input="changePage"
            v-model="paginated_data['current']"
            :total="paginated_data['count']"
            :perPage="paginated_data['per_page']"
          ></base-pagination>
        </div>
      </card>

      <!-- CARD MILHO BOM-->
      <card v-if="condition_2">
        <h3 class="mb-4">Campanha Milho Bom</h3>
        <form>
          <div class="row">
            <div class="col-md-10">
              <base-input
                label="Nome da Campanha"
                placeholder="Milho Bom"
                v-model="filter.name"
              />
            </div>
            <div class="col-md-2">
              <div style="margin-top: 2rem;">
                <base-button icon type="primary" v-on:click="search">
                  <span class="btn-inner--icon"
                    ><i class="fa fa-search"></i
                  ></span>
                  <span class="btn-inner--text">Pesquisar</span>
                </base-button>
              </div>
            </div>
          </div>
        </form>
        <el-table
          v-loading="isLoading"
          class="table-responsive table-striped clickable-rows"
          header-row-class-name="thead-light"
          style="width: 100% !important; padding-top: 10px;"
          :data="campaigns"
          ref="campaigns"
        >
          <el-table-column label="Nome" prop="name" min-width="200px" sortable />
          <el-table-column label="Data Início" v-slot="{ row }" min-width="140px" sortable>
            {{ row.start_date | humanDate }}
          </el-table-column>
          <el-table-column label="Data Fim" v-slot="{ row }" min-width="140px" sortable>
            {{ row.end_date | humanDate }}
          </el-table-column>
          <el-table-column label="Ações" width="120px" v-slot="{ row }">
            <div class="row">
              <el-dropdown
                trigger="hover"
                class="dropdown"
                style="cursor: pointer;"
              >
                <span class="btn btn-sm btn-icon-only text-success">
                  <i class="fas fa-ellipsis-v mt-2"></i>
                </span>
                <el-dropdown-menu
                  class="dropdown-menu dropdown-menu-arrow show"
                  slot="dropdown"
                >
                  <a class="dropdown-item" href="#" @click="editMb(row)"
                    >Editar</a
                  >
                  <a class="dropdown-item" href="#" @click.prevent="remove(row)"
                    >Excluir</a
                  >
                  <a
                    class="dropdown-item"
                    href="#"
                    @click="openModal('synthetic', row)"
                  >
                    Apuração Sintética
                  </a>
                  <a
                    class="dropdown-item"
                    href="#"
                    @click="openModal('analytical', row)"
                  >
                    Apuração Analítica
                  </a>
                </el-dropdown-menu>
              </el-dropdown>
              <el-tooltip content="Visualizar Descontos" placement="top">
                <a @click="rowClicked(row, true)">
                  <span class="btn btn-sm btn-icon-only text-success">
                    <i class="fa fa-eye mt-2"></i>
                  </span>
                </a>
              </el-tooltip>
            </div>
          </el-table-column>
          <el-table-column :min-width="1" type="expand">
            <template align="right" slot-scope="props">
              <div class="card-deck">
                <card>
                  <h5 class="card-title">Porcentagem do Produto</h5>
                  <div v-if="rowExpanded" class="tags-input__wrapper">
                    <p>
                      {{
                        props.row.percentages_campaigns[0].product_percentage ||
                        0
                      }}%
                    </p>
                  </div>
                  <h5 class="card-title">Quantidade Mínima de Saco de Milho</h5>
                  <div v-if="rowExpanded" class="tags-input__wrapper">
                    <p>
                      {{ props.row.percentages_campaigns[0].corn_bags || 0 }}
                    </p>
                  </div>
                </card>
                <card>
                  <h5 class="card-title">Porcentagem Mínima</h5>
                  <div v-if="rowExpanded" class="tags-input__wrapper">
                    <p>
                      {{
                        props.row.percentages_campaigns[0].corn_percentage || 0
                      }}%
                    </p>
                  </div>
                  <h5 class="card-title">
                    Porcentagem Adicional por Saco de Milho
                  </h5>
                  <div v-if="rowExpanded" class="tags-input__wrapper">
                    <p>
                      {{
                        props.row.percentages_campaigns[0]
                          .discount_percentage || 0
                      }}%
                    </p>
                  </div>
                </card>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="py-4 d-flex justify-content-end">
          <base-pagination
            v-on:input="changePage"
            v-model="paginated_data['current']"
            :total="paginated_data['count']"
            :perPage="paginated_data['per_page']"
          ></base-pagination>
        </div>
      </card>
    </card>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Select,
  Option,
  DatePicker,
} from "element-ui";
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import { ValidationProvider, extend } from "vee-validate";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { required } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});

export default {
  name: "app",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    PageTitle,
    Multiselect,
    ValidationProvider,
    flatPicker,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [DatePicker.name]: DatePicker,
  },
  data() {
    return {
      modals: {
        harvest: false,
        modal1: false,
        corn: false,
        campaign: false,
      },
      json_fields_synthetic: {
        CLIENTE: "client",
        TOTAL: "total",
        "PRODUTO CHAVE": "total_key_product",
        "% PRODUTO CHAVE": "key_product_percentage",
        DESCONTO: "discount_per_product",
        "DESCONTO CONCEDIDO": "granted_discount",
      },
      isLoadingReport: true,
      json_fields_analytical: {
        "NOTA FISCAL": "note",
        VENDEDOR: "salesmen",
        CLIENTE: "client",
        MATERIAL: "material",
        "KG/L": "kg_lt",
        QUANTIDADE: "amount",
        VALOR: "tota_not",
        DESCONTO: "discount_per_product",
      },
      report_type: "",
      report_data: [],
      brands: [],
      campaign_products: [],
      campaigns: [],
      campaign: {
        percentages_campaigns_attributes: [{}],
        percentages_campaigns_attributes: [{}],
        enterprises: [],
        corn_providers: [],
        providers: [],
      },
      campaign_type: {},
      campaignz: {},
      errors: {},
      errorMilhoBom: {},
      hasDiscount: false,
      end_date: "Data de Fim",
      enterprises: [],
      formData: {},
      data_synthetic: [],
      data_analytical: [],
      filter: {
        preferredproduct_name: "",
        product: {},
        products: [],
        brand: {},
        brands: [],
        isLoadingProduct: true,
      },
      condition_1: false,
      condition_2: false,
      campaign_id: "",
      corns: [
        {
          corn_condition: "",
          corn_brand_percentage: "",
          corn_corn_bags: "",
          corn_corn_percentage: "",
          corn_discount_percentage: "",
        },
      ],
      filterBrands: null,
      filterPreferredproducts: [],
      filtered: false,
      isTouchedType: false,
      paginated_data: [],
      products: [],
      products_id: [],
      editTitle: false,
      preferredproducts: [],
      products_brands: [],
      rowExpanded: {},
      start_date: "Data de Início",
      valueDiscount: [],
      valueBrandPercentage: [],
      searchProductsTimer: null,
      searchProductsLoading: false,
      harvests: [
        {
          harvest_condition: "",
          harvest_discount_percentage: "",
          harvest_product_percentage: "",
        },
      ],
      isLoadingEnterprise: false,
      isCreatingMb: false,
      isCreatingSb: false,
    };
  },
  created() {
    if (this.$can("index")) {
      this.setData();
      this.setStaticData();
    }
    this.getPreferredProducts();
  },
  methods: {
    validateForm() {
      this.errors = {};

      if (!this.campaign.brand)             this.errors.brand                   = "Campo Fornecedor do Produto é obrigatório."
      if (!this.campaign.preferredproduct)  this.errors.preferredproduct        = "Campo Produto Chave é obrigatório"
      if (!this.campaign.enterprises)       this.errors.enterprises             = "Campo Empresa é obrigatório"
      if (!this.campaign.name)              this.errors.name                    = "Campo Nome da Campanha é obrigatório"

      if (Object.keys(this.errors).length > 0) return false;

      return true;
    },

    validateFormMilho(){
      this.errorMilhoBom = {}

      if (!this.campaign.providers || this.campaign.providers.length === 0) {
        this.errorMilhoBom.providers = "Campo Fornecedores do Produto é obrigatório";
      }
      if (!this.campaign.key_products || this.campaign.key_products.length === 0) {
        this.errorMilhoBom.key_products = "Campo Produto Chave é obrigatório"
      } 
      if (!this.campaign.preferredproduct_ids || this.campaign.preferredproduct_ids.length === 0) {
        this.errorMilhoBom.preferredproduct_ids = "Campo Produtos Participantes é obrigatório"
      }
      if (!this.campaign.enterprises || this.campaign.enterprises.length === 0){
        this.errorMilhoBom.enterprises = "Campo Empresa é Obrigatório"
      }
      if (!this.campaign.name || this.campaign.name.length === 0) {
        this.errorMilhoBom.name = "Campo Nome da Campanha é obrigatório"
      }

      return Object.keys(this.errorMilhoBom).length === 0;
    },
    validateAll() {
      return this.validateForm() || this.validateFormMilho();
    },
    clickedSb() {
      this.condition_1 = true;
      this.campaign_type = "sb_bayer";
      this.getCampaign(1, this.campaign_type);
      this.condition_2 = false;
    },
    clickedMb() {
      this.condition_1 = false;
      this.campaign_type = "mb_bayer";
      this.getCampaign(1, this.campaign_type);
      this.condition_2 = true;
    },
    addCampaignHarvest() {
      if (!this.campaign.percentages_campaigns_attributes) {
        this.campaign = Object.assign({}, this.campaign, {
          percentages_campaigns_attributes: [],
        });
      }

      this.campaign.percentages_campaigns_attributes.push({
        condition: "",
        product_percentage: "",
        discount_percentage: "",
        _destroy: false,
      });

      if (this.campaign && this.campaign.discount_percentage != null) {
        this.hasDiscount = true;
      }

      this.campaign = Object.assign({}, this.campaign);
    },
    addCampaignCorn() {
      if (!this.campaign.percentages_campaigns_attributes) {
        this.campaign = Object.assign({}, this.campaign, {
          percentages_campaigns_attributes: [],
        });
      }

      this.campaign.percentages_campaigns_attributes.push({
        condition: "",
        product_percentage: "",
        corn_bags: "",
        corn_percentage: "",
        discount_percentage: "",
        _destroy: false,
      });

      if (discount_percentage != null) {
        this.hasDiscount = true;
      }

      this.campaign = Object.assign({}, this.campaign);
    },
    clone(obj) {
      return Object.assign({}, obj);
    },
    renameKey(oldKey, newKey) {
      const oldObj = this.json_fields_synthetic;
      const renameObjKey = () => {
        const keys = Object.keys(oldObj);
        const newObj = keys.reduce((acc, val) => {
          if (val === oldKey) acc[newKey] = oldObj[oldKey];
          else acc[val] = oldObj[val];
          return acc;
        }, {});

        return newObj;
      };
      return renameObjKey();
    },
    openModal(type, campaign) {
      this.isLoadingReport = true;
      this.modals.campaign = true;
      this.report_type = type;
      // rename key value
      if (campaign.preferredproduct && campaign.preferredproduct.name)
        this.json_fields_synthetic = this.renameKey(
          "PRODUTO CHAVE",
          `${campaign.preferredproduct.name}`
        );

      type == "synthetic"
        ? this.syntheticVerification(campaign)
        : this.analyticalVerification(campaign);
    },
    closeModal() {
      this.modals.campaign = false;
    },
    async syntheticVerification(campaign) {
      try {
        const response = await this.$http.secured.get(
          "/api/v1/report/verification_campaign.xlsx",
          {
            params: { service_params: { campaign_id: campaign.id, synthetic: true }},
            responseType: 'blob',
          }
        );
        this.report_data = response.data;
        this.downloadExcel(response.data, "relatorio_sintetico.xlsx");
        this.isLoadingReport = false;

        if (this.report_data.length === 0) {
          this.$toasted.global.defaultError({
            msg: "Não há dados para apuração sintética",
          });
        }
      } catch (error) {
        this.$toasted.global.defaultError({
          msg: "Não foi possível gerar o Excel",
        });
      }
    },
    async analyticalVerification(campaign) {
      try {
        const response = await this.$http.secured.get(
          "/api/v1/report/verification_campaign.xlsx",
          {
            params: { service_params: { campaign_id: campaign.id, synthetic: false }},
            responseType: 'blob',
          }
        );
        this.report_data = response.data;
        this.downloadExcel(response.data, "relatorio_analitico.xlsx");
        this.isLoadingReport = false;

        if (this.report_data.length === 0) {
          this.$toasted.global.defaultError({
            msg: "Não há dados para apuração analítica",
          });
        }
      } catch (error) {
        this.$toasted.global.defaultError({
          msg: "Não foi possível gerar o Excel",
        });
      }
    },

    downloadExcel(data, filename) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); 
    },
    removeHarvest(harvest) {
      this.campaign.percentages_campaigns_attributes = this.campaign.percentages_campaigns_attributes.filter(
        (el) => el != harvest
      );

      if (harvest.id != null) {
        this.campaign.percentages_campaigns_attributes.push({
          id: harvest.id,
          _destroy: "1",
        });

        this.campaign = Object.assign({}, this.campaign);
      }
    },
    removeCorn(corn) {
      this.campaign.percentages_campaigns_attributes = this.campaign.percentages_campaigns_attributes.filter(
        (el) => el != corn
      );

      if (harvest.id != null) {
        this.campaign.percentages_campaigns_attributes.push({
          id: harvest.id,
          _destroy: "1",
        });

        this.campaign = Object.assign({}, this.campaign);
      }
    },
    findProducts(query) {
      let array = this.campaign.providers;

      var data = {
        per_page: 10,
        q: { name: query, brands: array },
        name_only: true,
      };

      if (this.campaign.brand && this.campaign.brand.name)
        data.q["brand"] = this.campaign.brand.name;

      this.$http.secured
        .get("/api/v1/preferredproducts", { params: data })
        .then((response) => {
          this.filter.isLoadingProduct = false;
          this.preferredproducts = response.data;
          this.filterPreferredproducts = response.data;
        })
        .catch(() =>{
          //  this.$toasted.global.defaultError()
          });
    },
    changePage(page) {
      this.getCampaign(page, this.campaign_type);
    },
    edit(campaign) {
      this.campaign = campaign;
      this.campaign.percentages_campaigns_attributes =
        campaign.percentages_campaigns;
      this.modals.harvest = true;
      this.isCreatingSb = false;
    },
    editMb(campaign) {
      this.campaign = campaign;
      this.campaign.percentages_campaigns_attributes =
        campaign.percentages_campaigns;
      this.modals.corn = true;
      this.isCreatingMb = false;
    },
    getPreferredProducts(page = 1, query = null) {
      this.$http.secured
        .get("/api/v1/preferredproducts", {
          params: {
            page: page,
            q: query,
          },
        })
        .then((response) => {
          this.preferredproducts = response.data.preferredproducts;
        });
    },
    getCampaign(page, campaign_type) {
      this.isLoading = true;
      let query = { campaign_type: campaign_type };
      this.$http.secured
        .get("/api/v1/campaigns", {
          params: {
            page: page,
            q: query,
          },
        })
        .then((response) => {
          this.paginated_data = response.data;
          this.campaigns = this.paginated_data["campaigns"];
          this.isLoading = false;
        });
    },
    getCampaignMb(page) {
      this.isLoading = true;
      let query = { campaign_type: "mb_bayer" };
      if (page) query["page"] = page;
      this.$http.secured
        .get("/api/v1/campaigns", {
          params: { q: query },
        })
        .then((response) => {
          this.campaigns = response.data.campaigns;
          this.isLoading = false;
        });
    },
    async getEnterprises(q = "") {
      this.isLoadingEnterprise = true;
      try {
        const response = await this.$http.secured.get("/api/v1/report/enterprise_data", {
          params: { 
            q: { iden_emp: q, situ_emp: "A" } 
          },
        })
        this.newEnterprises = response.data;
        this.newEnterprises.shift();
        this.newEnterprises.shift();
        this.enterprises = this.newEnterprises.sort((a, b) => {
          if (a.iden_emp < b.iden_emp) return -1;
          if (a.iden_emp > b.iden_emp) return 1;
          return 0;
        });
      } catch (error) {
        this.setError( error,this.$toasted.global.defaultWarnig({msg: "Empresas não encontradas"}));
        console.error("[Campaign][getEnterprises]", error);
        this.isLoadingEnterprise = false;
      } finally {
        this.isLoadingEnterprise = false;
      }
    },
    loadBrands() {
      this.$http.secured
        .get("/api/v1/brands", {
          params: {
            unpaged: true,
          },
        })
        .then((response) => {
          this.brands = response.data;
        });
    },
    newCampaign() {
      this.campaign = {};
      this.campaign_type = "sb_bayer";
      this.modals.harvest = true;
      this.isCreatingSb = true;
    },
    newCampaignz() {
      this.campaign = {};
      this.campaign_type = "mb_bayer";
      this.modals.corn = true;
      this.isCreatingMb = true
    },
    onTouch(campo) {
      switch (campo) {
        case "type":
          this.isTouchedType = true;
          break;
      }
    },
    rowClicked(row, ok) {
      // Se o botão de detalhes for clicado, expandir linha
      if (ok === true) {
        if (this.rowExpanded === row) {
          this.$refs.campaigns.toggleRowExpansion(row, false);
          this.rowExpanded = null;
          return;
        }
        if (this.rowExpanded !== null) {
          this.$refs.campaigns.toggleRowExpansion(this.rowExpanded, false);
        }

        this.$refs.campaigns.toggleRowExpansion(row, true);
        this.rowExpanded = row;
      }
    },
    remove(campaign) {
      this.$http.secured
        .delete(`/api/v1/campaigns/${campaign.id}`)
        .then((response) => {
          console.log("response: ", response.data);
          this.$toasted.global.defaultSuccess();

          if (this.campaign_type == "mb_bayer") {
            this.clickedMb();
          } else {
            this.clickedSb();
          }
        })
        .catch((error) => {
          this.setError(error, "Cannot remove Campaign");
          this.$refs.observer.setErrors(this.errors);
        });
    },
    resetInputs() {
      this.filter = {};
      this.campaign = {};
    },
    setError(error, text) {
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        text;
    },
    setData(q, page) {
      if (typeof page === "undefined") page = null;
      if (typeof q === "undefined" || this.emptyFilter) q = null;

      this.$http.secured
        .get(`/api/v1/campaigns`, {
          params: {
            campaign_id: this.$route.params.campaign_id,
            page: page,
            q: {
              campaign_type: this.campaign_type,
              ...q,
            },
          },
        })
        .then((response) => {
          this.paginated_data = response.data;
          this.campaigns = this.paginated_data["campaigns"];
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    search() {
      delete this.campaign.product_provider;

      if (this.campaign.product_provider)
        this.campaign.product_provider = this.campaign.product_provider.name;
      this.filtered = !this.emptyFilter;
      this.setData(this.normalizedFilter);
    },
    searchProducts(name) {
      if (this.searchProductsTimer) clearTimeout(this.searchProductsTimer);

      this.searchProductsTimer = setTimeout(() => {
        this.getPreferredProducts(1, { name: name });
      }, 300);
    },
    save() {
      if (this.campaign.id) {
        this.update();
      } else {
        this.create();
      }
    },
    async create() {
      if (!this.validateAll()) return;

      try {
        await  this.$http.secured
        .post("/api/v1/campaigns", { campaign: this.postData })

        this.$toasted.global.defaultSuccess();
        this.setData();
        this.modals.harvest = false;
        this.modals.modal1 = false;
        this.modals.corn = false;
        this.resetInputs();
        this.$refs.observer.reset();
      } catch (error)  {
        console.warn("[Campaign] create", error)
        this.setError(error, "Cannot save Sector");
        this.$refs.observer.setErrors(this.errors);
      };
    },
    async update() {
      if (!this.validateAll()) return;
      
      try {
        await this.$http.secured.put(`/api/v1/campaigns/${this.campaign.id}`, {
          campaign: this.postData,
        })
  
        this.modals.harvest = false;
        this.modals.corn = false;
        this.resetInputs();
        this.$refs.observer.reset();
        this.$toasted.global.defaultSuccess();
        this.setData();
      } catch (error) {
        console.warn("[Campaign] update", error)
        this.setError(error, "Cannot save Sector");
        this.$refs.observer.setErrors(this.errors);
      }
    },
    handleClearIconClick() {
      if (this.campaign.start_date || this.campaign.end_date) {
        this.campaign.start_date = '';
        this.campaign.end_date = '';
      }
    }
  },
  computed: {
    postData() {
      return {
        name: this.campaign.name,
        preferredproduct_id: this.campaign.preferredproduct
          ? this.campaign.preferredproduct.id
          : null,
        preferredproduct_ids: this.campaign.preferredproduct_ids,
        start_date: this.campaign.start_date,
        brand_id: this.campaign.brand ? this.campaign.brand.id : null,
        key_products: this.campaign.key_products
          ? this.campaign.key_products
          : null,
        providers: this.campaign.providers ? this.campaign.providers : null,
        corn_providers: this.campaign.corn_providers
          ? this.campaign.corn_providers
          : null,
        end_date: this.campaign.end_date,
        percentages_campaigns_attributes: this.campaign
          .percentages_campaigns_attributes,
        campaign_type: this.campaign_type,
        enterprises: this.campaign.enterprises,
      };
    },
    dateRange: {
      get: function () {
        // eslint-disable-next-line
        /* eslint-disable */

        return [this.campaign.start_date, this.campaign.end_date];
      },
      set: function (range) {
        this.campaign = Object.assign({}, this.campaign, {
          start_date: range[0],
          end_date: range[1],
        });
      },
    },
    emptyFilter: function () {
      for (var key in this.filter) {
        if (
          this.filter.hasOwnProperty(key) &&
          this.filter[key] != "" &&
          typeof this.filter[key] != "undefined"
        ) {
          return false;
        }
      }
      return true;
    },
    reqParams: function () {
      if (this.campaign.hasOwnProperty("id")) {
        return {
          url: `/api/v1/campaigns/${this.campaign.id}`,
          method: "patch",
          data: {
            campaign_type: this.campaign_type,
            ...this.campaign,
          },
        };
      }
      return {
        url: "/api/v1/campaigns",
        method: "post",
        data: {
          campaign_type: this.campaign_type,
          ...this.campaign,
        },
      };
    },
    normalizedFilter: function () {
      let filter = this.filter;
      for (let key in filter) {
        // replacing objects by ids
        if (filter.hasOwnProperty(key) && typeof filter[key] == "object") {
          if (filter[key].hasOwnProperty("id")) {
            filter[key + "_id"] = filter[key].id;
            delete filter[key];
          } else {
            filter[key] = filter[key].value;
          }
        }
        // removing empty fields
        if (filter[key] == "") {
          delete filter[key];
        }
      }

      return filter;
    },
  },

  mounted() {
    this.getEnterprises();
    this.loadBrands();
  },

  watch: {
    "campaign.preferredproduct": {
      handler: function (after, before) {
      },
      deep: true,
    },
    "campaign.brand": function () {
      this.campaign.product_provider = this.campaign.brand.name;
      this.findProducts("");
    },
    "campaign.providers": function () {
      this.findProducts();
    },
    start_date: function () {
      this.campaign.start_date = this.start_date;
    },
    end_date: function () {
      this.campaign.end_date = this.end_date;
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.el-select {
  /* width: 451px; */
  height: 42px;
  outline: 0;
}

@media (max-width: 768px) {
  .product-participant{
    font-size: 10px;
  }
}

.button-class {
  color: #C0C4CC;
  position: absolute;
  top: 58%;
  right: 30px;
  transform: translateY(-50%);
}

</style>
